import React, { useState, useEffect } from 'react'
import {
  Grid,
  FormControl,
  Button,
  // Select,
  // MenuItem,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from '@material-ui/core'
import './Style/crearFormulario.scss'

// import { useAuthentication } from '../../../context/authenticationContext'

// import * as Yup from 'yup'
// import { useFormik } from 'formik'
// import { useHistory } from 'react-router-dom'
// import swal from 'sweetalert'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
// import { createForm } from '../../../services/Forms/create'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { ModalMaps } from '../../Elegibilidad/Maps/ModalMaps'
import NumberFormat from 'react-number-format'
import Table31 from './Tables/TablesSec3/Table31'
import Table33 from './Tables/TablesSec3/Table33'
import Table35 from './Tables/TablesSec3/Table35'
import Table36 from './Tables/TablesSec3/Table36'

import { useFormElegibilidad } from '../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../context/EligibilityContext'
import Accordion9 from './AccordionSec3/Pregunta9'
import {
  getLocationsByForm,
  getProductionAndLossByForm,
} from '../../../../services/Elegibilidad/get'

const ElegibilidadSec3View = (props) => {
  const { goToStep } = props
  const { EligibilityForm } = useFormElegibilidad()

  const [state, dispatch] = useEligibility()

  // Modales
  const [open, setOpen] = useState(false)

  const next = () => {
    goToStep(4)
    dispatch({ type: 'SET_STATE', payload: 4 })
  }

  const previous = () => {
    goToStep(2)
    dispatch({ type: 'SET_STATE', payload: 2 })
  }

  // tables
  const [tableDataLocation, setTableDataLocation] = useState([])
  const [tableProductionandLoss, setTableProductionandLoss] = useState([])

  // funcion para obtener las ubicaciones del proyecto
  const getDataTableLocation = async () => {
    try {
      const response = await getLocationsByForm(
        EligibilityForm.IdElegibilityAnswer,
      )
      if (response.Success) setTableDataLocation(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  // funcion para tabla 3.3
  // funcion para obtener la data de la tabla 3.3 y 3.5
  const getDataTableProductionAndLoss = async () => {
    try {
      const response = await getProductionAndLossByForm(
        EligibilityForm.IdElegibilityAnswer,
      )
      if (response.Success) setTableProductionandLoss(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 3 &&
      EligibilityForm.IdElegibilityAnswer !== undefined &&
      EligibilityForm.IdElegibilityAnswer !== null
    ) {
      getDataTableLocation()
      getDataTableProductionAndLoss()
    }
  }, [state.step])

  return (
    <>
      <form id="sec3-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">
            EXPOSICIÓN A LOS IMPACTOS DEL CAMBIO CLIMÁTICO, VULNERABILIDAD Y
            CAPACIDADES DE ADAPTACIÓN
          </h1>
          <br />
        </Grid>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.1. Localización de la MIPYME / Miembros o Asociados
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Indique la ubicación de la MIPYME / miembros y asociados que se
                beneficiarán de las actividades del subproyecto.
              </label>
              <br></br>
              <br></br>
            </Grid>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <Typography>
                  1. ¿En cuántos sitios se desarrollará el proyecto a financiar?
                  <a
                    data-tip="Si su proyecto se ejecutará en 2 o más sitios, indique la cantidad"
                    data-for="infoCurrencyPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoCurrencyPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="ProjectSites"
                    name="ProjectSites"
                    style={{ width: '100%' }}
                    variant="outlined"
                    customInput={TextField}
                    thousandSeparator={true}
                    displayType={'input'}
                    inputProps={{ maxLength: 4 }}
                    decimalScale={0}
                    value={EligibilityForm.ProjectSites}
                    disabled
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <ModalMaps open={open} setOpen={setOpen} />
              </Grid>
            </Grid>

            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table31
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                  getDataTableLocation={getDataTableLocation}
                  tableDataLocation={tableDataLocation}
                ></Table31>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.2. Peligros climáticos para el ecosistema-producción
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Peligros climáticos</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    id="ClimateThreat"
                    placeholder="Peligros Climáticos"
                    customInput={TextField}
                    value={EligibilityForm.ClimateThreat}
                    disabled
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.3. Producción y número de hectáreas expuestas a los efectos del
              cambio y a la variabilidad climática{' '}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table33
                  getDataTableProductionAndLoss={getDataTableProductionAndLoss}
                  tableProductionandLoss={tableProductionandLoss}
                ></Table33>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.4. Descripción de los impactos negativos del peligro climático
              en la producción y el ecosistema
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Impactos negativos</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Impactos Negativos"
                    customInput={TextField}
                    value={EligibilityForm.NegativeImpact}
                    disabled
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.5. Pérdida de producción debido a eventos relacionados con el
              clima
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Proporcione una estimación anual de la pérdida de producción
                resultante del evento climático más reciente dentro los últimos
                5 años: El tipo de producción de medida (p. Ej= Quintales por
                año / Toneladas por año / Número de ganado por año/ Ocupación
                por año). En la columna antecedentes, describa el evento
                climático más reciente.
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table35
                  tableProductionandLoss={tableProductionandLoss}
                ></Table35>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.6. Pérdida de activos físicos debido a eventos relacionados con
              el clima
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Proporcione una estimación anual de daños o pérdidas a MIPYME o
                activos físicos privados, debido a eventos relacionado con el
                clima. (No obligatoria)
                <a
                  data-tip="Puede llenar 1 hasta 5 registros, según su caso. "
                  data-for="info6Pop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="info6Pop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table36
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                ></Table36>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.7. Acceso al agua potable
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1. ¿Posee la MIPYME acceso al agua apta para consumo humano?{' '}
                  <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }} disabled>
                  <RadioGroup
                    id="isNativeCommunity"
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    disabled
                    value={EligibilityForm.AccDrinkinWater}
                    row
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Si"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            {EligibilityForm.AccDrinkinWater === true ? (
              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">2. Fuente de agua:</label>
                </Grid>
                {/* TABLE */}
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox value="AdwRain" disabled />}
                        label="Lluvia"
                        checked={EligibilityForm.AdwRain}
                      />
                      <FormControlLabel
                        control={<Checkbox value="AdwGroundWater" disabled />}
                        label="Aguas Subterráneas"
                        checked={EligibilityForm.AdwGroundWater}
                      />
                      <FormControlLabel
                        control={<Checkbox value="AdwDrinkinWater" disabled />}
                        label="Agua Potable"
                        checked={EligibilityForm.AdwDrinkinWater}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="AdwVariousSources"
                            disabled
                            checked={EligibilityForm.AdwVariousSources}
                          />
                        }
                        label="Ríos, lagos, arroyos y manantiales naturales"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.8. Seguridad alimentaria
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1. ¿En los hogares de socios y empleados/colaboradores de la
                  MIPYME corren el riesgo de no producir o no poder comprar /
                  obtener suficiente comida, debido a eventos relacionados con
                  el clima? <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }} disabled>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="foodInfomation"
                    value={EligibilityForm.FoodSafety}
                    row
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Si"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  2. ¿Cuántos de estos hogares corren el riesgo de no producir o
                  no poder comprar / obtener suficiente comida, debido a eventos
                  relacionados con el clima?{' '}
                </label>
                <br></br>
              </Grid>

              <Grid container spacing={1}>
                {/* MUJERES */}
                <Grid item xs={6} sm={6} md={6}>
                  <label className="responsiveLabel">
                    Hogares dirigidos por mujeres:
                    <a
                      data-tip="Se refiere a hogares en los que la jefe de
                  familia es una mujer (mujeres solteras,
                  viudas, separadas, con ausencia del
                  compañero)"
                      data-for="info82Pop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="info82Pop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                    <br></br>
                    <br></br>
                  </label>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="FSHomesWomen"
                      style={{ width: '100%' }}
                      customInput={TextField}
                      thousandSeparator={true}
                      variant="outlined"
                      value={EligibilityForm.FSHomesWomen}
                      disabled
                    />
                  </FormControl>
                </Grid>
                {/** HOMBRES */}
                <Grid item xs={6} sm={6} md={6}>
                  <label className="responsiveLabel">
                    Hogares dirigidos por hombres:
                    <a
                      data-tip="Se refiere a hogares en los que el jefe de
                        familia es un hombre."
                      data-for="info821Pop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="info821Pop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                    <br></br>
                    <br></br>
                  </label>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="FSHomesMen"
                      style={{ width: '100%' }}
                      customInput={TextField}
                      thousandSeparator={true}
                      variant="outlined"
                      value={EligibilityForm.FSHomesMen}
                      disabled
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.9. Capacidades adaptativas
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <Accordion9
                  idElegibilityNew={EligibilityForm.IdElegibilityAnswer}
                  // formik={formik}
                  tableProductionandLoss={tableProductionandLoss}
                ></Accordion9>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        {/** botones siguientes y anterior */}

        <Grid container spacing={1}>
          <Grid container spacing={1} className="button__container">
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
                // disabled={loading}
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                >
                  <Button
                    onClick={() => {
                      next()
                    }}
                    className="button__wizard button__next"
                  >
                    Siguiente
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default ElegibilidadSec3View
